import ProductImageGallery from '../components/productImageGallery';
import QR from '../components/qr';
import Accordion from '../components/accordion';
import FeaturedProductsSlider from '../components/featuredProductsSlider';
import QuantitySpinnerInput from '../components/quantitySpinnerInput';

const wooCommerceSingleProductObject = {};

export default {
  init() {},

  finalize() {
    wooCommerceSingleProductObject.productImageGallery = new ProductImageGallery(this);
    wooCommerceSingleProductObject.qr = new QR(this);
    wooCommerceSingleProductObject.accordion = new Accordion(this);
    wooCommerceSingleProductObject.featuredProductsSlider = new FeaturedProductsSlider(this);
    wooCommerceSingleProductObject.quantitySpinnerInput = new QuantitySpinnerInput(this);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce-single-product.js